import { render } from "./TermsView.vue?vue&type=template&id=3c23b2fb&scoped=true"
const script = {}

import "./TermsView.vue?vue&type=style&index=0&id=3c23b2fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c23b2fb"]])

export default __exports__